import { render, staticRenderFns } from "./layer-add-edit-dictionary.vue?vue&type=template&id=e9c0375e&scoped=true&"
import script from "./layer-add-edit-dictionary.vue?vue&type=script&lang=js&"
export * from "./layer-add-edit-dictionary.vue?vue&type=script&lang=js&"
import style0 from "./layer-add-edit-dictionary.vue?vue&type=style&index=0&id=e9c0375e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c0375e",
  null
  
)

export default component.exports